import "./Dashboard.css";
import React from "react";
import Footer from "examples/Footer";
import { Loader } from "components/loader/Loader";
import { useDocumentState } from "context/Documents";
import { useAuthState } from "context/Auth";
import { GetDocuments } from "api/DocumentAPI";
import StartCards from "components/document/StartCard";
import DocumentCards from "components/document/DocumentCard";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

function Dashboard() {
  const { documents } = useDocumentState() ?? {};
  const { user } = useAuthState();

  let docsLoading;
  if (!documents) {
    const { documentsLoading } = GetDocuments();
    docsLoading = documentsLoading;
  }

  const hour = new Date().getHours();
  const greeting =
    hour < 12 ? "Good morning" : hour < 17 ? "Good afternoon" : "Good evening";

  const name = user?.fullName?.split(" ")[0] ?? "";

  return (
    <>
      {docsLoading ? (
        <div style={{ display: "flex", justifyContent: "center", margin: "100px" }}>
          <Loader />
        </div>
      ) : (
        <div style={{ backgroundColor: "#f5f7fa", minHeight: "100vh" }}>
          <DashboardNavbar />
          <div style={{ maxWidth: 1100, margin: "0 auto", padding: "32px 24px 0" }}>
            <h2
              style={{
                fontFamily: "sans-serif",
                fontWeight: 700,
                fontSize: "1.6rem",
                color: "#012042",
                margin: 0,
              }}
            >
              {greeting}{name ? `, ${name}` : ""} 👋
            </h2>
            <p style={{ color: "#888", marginTop: 4, fontSize: "0.9rem" }}>
              {new Date().toLocaleDateString("en-US", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </p>
          </div>
          <StartCards />
          <DocumentCards documents={documents} />
          <Footer />
        </div>
      )}
    </>
  );
}

export default Dashboard;
